module.exports = __webpack_public_path__ + "img/pro-p-slider2.a455a21c.png";